export class Transcriber {
	constructor(component_key) {
		this.id = component_key;
		this.vars = yalwa.v.components[this.id];
		this.$root = jQuery(`.js-${this.id}`);
		this.$start_btn = null;
		this.$stop_btn = null;
		this.$stop_float = null;
	}

	init() {
		this.recognition = null;
		this.is_recording = false;
		this._observe_visibility();
	}

	_observe_visibility() {
		this._visibility_observer = new IntersectionObserver((entries) => {
			if (!entries[0].isIntersecting && this.is_recording) {
				this.stop_dictation();
			}
		});
		this._visibility_observer.observe(this.$root[0]);

		this._visibility_handler = () => {
			if (document.hidden && this.is_recording) {
				this.stop_dictation();
			}
		};
		document.addEventListener('visibilitychange', this._visibility_handler);
	}

	is_supported() {
		return !yalwa.v.is_phonegap && ('SpeechRecognition' in window || 'webkitSpeechRecognition' in window);
	}

	_language_matches() {
		const device_lang = (navigator.language || '').split('-')[0].toLowerCase();
		const page_lang = (document.documentElement.lang || '').toLowerCase();
		return device_lang === page_lang;
	}

	// GA tracking — fires event only if ga_category is set
	_track(action) {
		if (this.vars.ga_category) {
			yalwa.basics.ga.event({ category: this.vars.ga_category, action: this.tracking_section + '_' + action });
		}
	}

	// Mario logging — sets hidden input only if mario_log is set
	_log_mario() {
		if (this.vars.mario_log) {
			jQuery('.js-' + this.vars.mario_log).val(1);
		}
	}

	start_dictation() {
		this._set_text_before_after();
		this.stopped_by_user = false;
		this._continuous_broken = false;
		this._last_transcript = '';
		this._last_appended = '';

		const SR = window.SpeechRecognition || window.webkitSpeechRecognition;
		this.recognition = new SR();
		this.recognition.continuous = true;
		this.recognition.interimResults = true;
		this.recognition.unspokenPunctuation = true;

		this.recognition.onresult = (event) => {
			const result = event.results[event.resultIndex];
			
			const is_really_final =
				result.isFinal &&
				result[0].confidence > 0.1;
			
			const interim = result[0].transcript;
			this.set_textarea_value(this._build_display(interim));
			const pos = this._cursor_pos(interim);
			this.set_cursor_position(pos);
			const max = this.get_max_length();
			if (is_really_final) {
				this._set_text_before_after();
			}
			if (max && this.text_before.length >= max) {
				this.stop_dictation();
			}
		};
		
		this.recognition.onend = (e) => {
			if (this.stopped_by_user) {
				this.cleanup_recording();
				this.on_recording_end();
				this._set_text_before_after();
			} else {
				this._handle_continuous_end();
			}
		};

		this.recognition.onerror = (event) => {
			const permission_errors = [
				'not-allowed',
				'service-not-allowed',
				'audio-capture' // safari
			];
			if (permission_errors.includes(event.error)) {
				this.stopped_by_user = true;
				try { this.recognition.abort(); } catch (_) {}
				this.cleanup_recording();
				this.on_recording_end();
			}
		};



		this.recognition.start();
		this.is_recording = true;
		this._track('start');
		this._log_mario();
		this.$root.addClass('transcriber--recording');
		this.$start_btn?.addClass('hidden');
		this.$stop_btn?.removeClass('hidden');
		document.activeElement?.blur();
	}

	get_textarea_value() { return ''; }

	set_textarea_value(val) {}

	get_selection_start() { return 0; }

	get_selection_end() { return 0; }

	set_cursor_position(pos) {}

	get_max_length() { return 0; }

	focus_textarea() {}

	on_recording_end() {}

	stop_dictation() {
		if (this.recognition) {
			this.stopped_by_user = true;
			this.recognition.stop();
			this._track('stop');
		}
	}

	cleanup_recording() {
		this.is_recording = false;
		this.on_cleanup();
	}

	// Chrome Android ignores continuous=true and fires onend after each phrase.
	// Restart recognition to keep dictation active across pauses.
	_handle_continuous_end() {
		try {
			this.recognition.start();
		} catch (e) {
			this.cleanup_recording();
			this.on_recording_end();
		}
	}
	
	_set_text_before_after() {
		const start = this.get_selection_start();
		const end = this.get_selection_end();
		const val = this.get_textarea_value();
		this.text_before = val.substring(0, start);
		this.text_after = val.substring(end);
	}

	_build_display(interim) {
		let val = this.text_before;
		if (interim) {
			const trimmed = interim.trim();
			if (trimmed) {
				const capitalise = !val || /[.!?]\s*$/.test(val);
				const word = capitalise ? trimmed.charAt(0).toUpperCase() + trimmed.slice(1) : trimmed;
				val += (val && val[val.length - 1] !== ' ' ? ' ' : '') + word;
			}
		}
		if (this.text_after && val && val[val.length - 1] !== ' ' && this.text_after[0] !== ' ') {
			val += ' ';
		}
		return val + this.text_after;
	}

	_cursor_pos(interim) {
		let pos = this.text_before.length;
		if (interim) {
			const trimmed = interim.trim();
			if (trimmed) {
				pos += (pos && this.text_before[this.text_before.length - 1] !== ' ' ? 1 : 0) + trimmed.length;
			}
		}
		return pos;
	}

	_bind_cursor_tracking($target) {
		this.setting_value = false;
		const update = () => {
			if (this.is_recording && !this.setting_value) {
				const start = this.get_selection_start();
				const end = this.get_selection_end();
				const val = this.get_textarea_value();
				this.text_before = val.substring(0, start);
				this.text_after = val.substring(end);
				this._last_transcript = '';
				this._last_appended = '';
			}
		};
		$target.on('input click keyup', update);
	}

	on_cleanup() {
		this.$root.removeClass('transcriber--recording');
		this.$start_btn?.removeClass('hidden');
		this.$stop_btn?.addClass('hidden');
		this.$stop_float?.addClass('hidden');
	}
}
